import { render, staticRenderFns } from "./DataCashbillNuera.vue?vue&type=template&id=075906c6&"
import script from "./DataCashbillNuera.vue?vue&type=script&lang=js&"
export * from "./DataCashbillNuera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports